import { Component, OnDestroy, OnInit } from '@angular/core'
import { LoadingController } from '@ionic/angular/standalone'
import { Subject, takeUntil } from 'rxjs'

import { LoadingService } from './loading.service'

@Component({
	selector: 'app-loading',
	templateUrl: './loading.component.html',
	standalone: true,
})
export class LoadingComponent implements OnInit, OnDestroy {
	private readonly destroy$ = new Subject<void>()

	constructor(
		private readonly loadingController: LoadingController,
		private readonly loadingService: LoadingService,
	) {}

	ngOnInit() {
		this.loadingService.loadingVisibility$.pipe(takeUntil(this.destroy$)).subscribe({
			next: async (visible) => {
				if (visible) {
					await this.showLoading()
				} else {
					await this.closeLoading()
				}
			},
		})
	}

	ngOnDestroy() {
		this.destroy$.next()
		this.destroy$.complete()
	}

	/**
	 * Create an ionic loading animation
	 */
	async showLoading() {
		if (!(await this.loadingController.getTop())) {
			const loading = await this.loadingController.create({
				spinner: 'bubbles',
				duration: this.loadingService.duration,
			})

			await loading.present()
		}
	}

	/**
	 * Dismiss the opened loading animation
	 * @private
	 */
	async closeLoading() {
		if (await this.loadingController.getTop()) {
			await this.loadingController.dismiss()
		}
	}
}
